import {formatter, request} from '@/utils/request';

export namespace ECMKT {
  export const Path = {
    Search: '/expenseapi/ecMkt/search',
    SearchForEcMkt3: '/expenseapi/ecMkt/searchEcMkt3',
    Get: '/expenseapi/ecMkt/get',
    Delete: '/expenseapi/ecMkt/delete',
    Post: '/expenseapi/ecMkt/post',
    GetEcMktStructures: '/expenseapi/ecMkt/getEcMktStructures',
    ExportEcMkt: '/expenseapi/ecMkt/exportEcMkt',
    GetEcMktStructureList: '/expenseapi/ecMkt/getEcMktStructureList',

  };

  export async function GetEcMktStructureList(body: API.EcStructureSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<Array<any>>>(Path.GetEcMktStructureList, formatter(options));
  }

  export async function searchEcMkt3(body: API.EcMktItemSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ECMKT[]>>(Path.SearchForEcMkt3, formatter(options));
  }

  export async function search(body: API.EcMktSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ECMKT[]>>(Path.Search, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ECMKT>>(Path.Get, formatter(options));
  }

  export async function del(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export async function post(body: API.ECMKT) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.ECMKT>>(Path.Post, formatter(options));
  }

  export async function GetEcMktStructures(ecLevel?: number) {
    const options = {
      method: 'GET',
      body: {
        ecLevel: ecLevel,
      },
    };
    return request<API.ResponseResult<API.EcMktStructure[]>>(
      Path.GetEcMktStructures,
      formatter(options),
    );
  }

  export async function exportEcMkt() {
    const options = {
      method: 'GET',
      body: {},
    };
    return request<API.ResponseResult<Array<any>>>(Path.ExportEcMkt, formatter(options));
  }
}
